import { ACTIONS, CallBackProps, EVENTS, STATUS } from "react-joyride"
import { TUTORIAL_TARGET_PROFIL_DOCS_PERSO, TUTORIAL_TARGET_PROFIL_DOCS_PRO } from "../targets/profile"
import { useAuth } from "../../../modules/auth"
import { useNavigate } from "react-router-dom"

const useTutorialProfile = () => {
     const { currentUser } = useAuth()
     const { setInteractiveTutorial } = useAuth()
     const navigate = useNavigate()

     const handleJoyrideCallback = (data: CallBackProps) => {
          const { action, index, type, status } = data

          if (status === STATUS.FINISHED) {
               handleOnFinishTutorial()
               return
          }
          if (status === STATUS.SKIPPED && !currentUser?.user?.isTutorialSeen) {
               handleOnSkipTutorial()
               return
          }

          if (type === EVENTS.TOUR_START) handleStart()

          if (type === EVENTS.STEP_AFTER) {
               // --------------------------
               // FORWARD logic (Next button)
               // --------------------------
               if (action === ACTIONS.NEXT) handleNext(index)

               // --------------------------
               // BACKWARD logic (Prev button)
               // --------------------------
               if (action === ACTIONS.PREV) handlePrevious(index)
          }
     }

     // Handles "start"
     const handleStart = () => navigate("/mon-compte/profil")

     // Handles "next"
     const handleNext = (index: number) => {
          // Step 3 → Step 4: Navigate to the "mes documents" page
          if (index === 2) navigate("/mon-compte/mes-documents")

          // Step 5 → Step 6: Automatically open the "professional documents" tab
          // by clicking on the corresponding element
          if (index === 4) {
               const el = document.querySelector(`.${TUTORIAL_TARGET_PROFIL_DOCS_PRO}`) as HTMLElement
               el?.click() // safely triggers click if element exists
          }

          // Step 6 → Step 7: Navigate to the settings page
          if (index === 5) navigate("/mon-compte/settings")

          // Advance the controlled step index by 1
          setInteractiveTutorial(prev => ({ ...prev, stepIndex: index + 1 }))
     }

     // Handles "previous"
     const handlePrevious = (index: number) => {
          // Step 6 → Step 5: Automatically open the "personal documents" tab
          if (index === 5) {
               const el = document.querySelector(`.${TUTORIAL_TARGET_PROFIL_DOCS_PERSO}`) as HTMLElement
               el?.click()
          }

          // Step 7 → Step 4: Navigate back to the "mes documents" page
          if (index === 6) {
               navigate("/mon-compte/mes-documents")
               setInteractiveTutorial(prev => ({ ...prev, stepIndex: 3 })) // set stepIndex explicitly to match target step
               return
          }

          // Step 4 → Step 2: Navigate back to the profile page
          if (index === 3) {
               navigate("/mon-compte/profil")
               setInteractiveTutorial(prev => ({ ...prev, stepIndex: 1 })) // set stepIndex explicitly to match target step
               return
          }

          // Default backward behavior: move back one step
          setInteractiveTutorial(prev => ({ ...prev, stepIndex: index - 1 })) // set stepIndex explicitly to match target step
     }

     // When user clicks on the finish button
     const handleOnFinishTutorial = () => {
          setInteractiveTutorial({
               isEnable: false,
               stepIndex: null,
               target: null,
          })
     }

     // When user clicks on "skip"
     const handleOnSkipTutorial = () => {
          setInteractiveTutorial({
               isEnable: false,
               stepIndex: null,
               target: null,
          })
     }

     return { handleJoyrideCallback, handleStart, handleNext, handlePrevious, handleOnFinishTutorial, handleOnSkipTutorial }
}

export default useTutorialProfile
